module.exports = __webpack_public_path__ + "static/media/video_promotion.d2752834.mp4";